import { render, staticRenderFns } from "./EditSections.vue?vue&type=template&id=7bd4ca88"
import script from "./EditSections.vue?vue&type=script&lang=js"
export * from "./EditSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports